<div class="py-4 px-8 bg-gray-200 min-h-screen w-full overflow-x-hidden">
  <div class="rounded-lg overflow-hidden shadow-md bg-white">
    <div class="flex items-center justify-between bg-[#00358E] py-3 px-8">
      <p class="text-white font-semibold">DynamoDB Utility</p>
    </div>

    <div class="flex flex-col gap-5 px-8 py-6">
      <div *ngIf="errorMessage" class="px-4 py-2 rounded bg-red-50 border border-red-200 text-red-700 text-sm">{{ errorMessage }}</div>

      <div class="flex flex-wrap gap-8">
        <label class="flex flex-col gap-1 text-sm font-medium text-[#2C2C2C]">
          Table
          <select [(ngModel)]="tableName" class="border rounded px-3 py-2 text-sm font-normal min-w-[360px] focus:outline-none focus:ring-2 focus:ring-blue-400">
            <option value="" disabled>Select a table</option>
            <option *ngFor="let table of tables" [value]="table">{{ table }}</option>
          </select>
        </label>

        <fieldset class="flex flex-col gap-1 text-sm font-medium text-[#2C2C2C]">
          <legend class="mb-1">Operation</legend>
          <div class="flex gap-6 py-2 font-normal">
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="radio" name="operation" value="upsert" [(ngModel)]="operation"> Insert / Update
            </label>
            <label class="flex items-center gap-2 cursor-pointer">
              <input type="radio" name="operation" value="delete" [(ngModel)]="operation"> Delete
            </label>
          </div>
        </fieldset>
      </div>

      <p class="text-sm text-[#555]">
        <ng-container *ngIf="operation === 'upsert'">Insert / Update replaces the whole item with the given key; attributes not in the JSON are removed.</ng-container>
        <ng-container *ngIf="operation === 'delete'">Delete uses only the table's key attributes from each item; other attributes are ignored.</ng-container>
        Paste one item, an array of items (up to 100), or <code>{{ '{' }}"Item": {{ '{' }}...{{ '}' }}{{ '}' }}</code>, in DynamoDB JSON, e.g.
        <code>{{ '{' }}"id": {{ '{' }}"S": "123"{{ '}' }}, "active": {{ '{' }}"BOOL": true{{ '}' }}{{ '}' }}</code>.
      </p>

      <label class="flex flex-col gap-1 text-sm font-medium text-[#2C2C2C]">
        Item JSON
        <textarea
          [(ngModel)]="itemsJson"
          (ngModelChange)="jsonError = ''"
          rows="18"
          spellcheck="false"
          class="border rounded px-3 py-2 font-mono text-xs font-normal focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder='[{"id": {"S": "123"}, "name": {"S": "Example"}}]'
        ></textarea>
      </label>
      <div *ngIf="jsonError" class="text-sm text-red-700">{{ jsonError }}</div>

      <div class="flex justify-end gap-3">
        <button type="button" (click)="formatJson()" [disabled]="!itemsJson.trim()"
          class="px-6 py-[10px] bg-white border border-[#00358E] rounded-[44px] text-base font-medium text-[#00358E] cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed">
          Format JSON
        </button>
        <button type="button" (click)="openConfirm()" [disabled]="!canSubmit"
          class="px-6 py-[10px] rounded-[44px] text-base font-medium text-white cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
          [ngClass]="operation === 'delete' ? 'bg-red-700' : 'bg-[#00358E]'">
          {{ isSubmitting ? 'Running...' : (operation === 'delete' ? 'Delete' : 'Insert / Update') }}
        </button>
      </div>

      <div *ngIf="result" class="flex flex-col gap-2">
        <div class="px-4 py-2 rounded text-sm border"
          [ngClass]="result.failed.length ? 'bg-yellow-50 border-yellow-200 text-yellow-800' : 'bg-green-50 border-green-200 text-green-800'">
          {{ result.succeeded }} of {{ result.total }} item(s) {{ result.operation === 'delete' ? 'deleted from' : 'written to' }} {{ result.tableName }}.
          <span *ngIf="result.failed.length">{{ result.failed.length }} failed.</span>
        </div>
        <ul *ngIf="result.failed.length" class="text-sm text-red-700 list-disc pl-6">
          <li *ngFor="let failure of result.failed">Item {{ failure.index + 1 }}: {{ failure.error }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation Modal -->
<div *ngIf="confirmOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
  <div class="bg-white rounded-[8px] shadow-2xl w-[500px] max-w-[90%] p-6">
    <h2 class="text-xl font-semibold text-[#1a1a1a] mb-2">Confirm {{ operation === 'delete' ? 'Delete' : 'Insert / Update' }}</h2>
    <p class="text-sm text-[#555] mb-6">
      {{ operation === 'delete' ? 'Delete' : 'Write' }} {{ itemCount }} item(s) {{ operation === 'delete' ? 'from' : 'to' }}
      <span class="font-semibold text-[#1a1a1a]">{{ tableName }}</span>? This cannot be undone.
    </p>
    <div class="flex justify-end gap-3">
      <button type="button" (click)="closeConfirm()" class="px-6 py-[10px] bg-white border border-[#00358E] rounded-[44px] text-base font-medium text-[#00358E] cursor-pointer">Cancel</button>
      <button type="button" (click)="execute()" class="px-6 py-[10px] rounded-[44px] text-base font-medium text-white cursor-pointer"
        [ngClass]="operation === 'delete' ? 'bg-red-700' : 'bg-[#00358E]'">Confirm</button>
    </div>
  </div>
</div>
